import { componentsThemeMap } from '../componentsThemeMap.js';
import { SectionComponentLayout } from '../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../providers/AnalyticsProvider.js';
import { CTAButtons } from '../ui/CTAButtons.js';
import '../ui/Div/index.js';
import { ErrorBoundary } from '../ui/ErrorBoundary.js';
import { ImageFullWidth } from '../ui/ImageFullWidth.js';
import { Text } from '../ui/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../ui/Div/Div.js';
function ActionBannerCenter({
  mediaUrl,
  mediaAlt,
  style = 'default',
  hasSpacingTop = false,
  anchor,
  headline,
  subhead,
  ctaButtonLabel,
  ctaButtonUrl
}) {
  const hasMedia = !!mediaUrl && !!mediaAlt;
  const _componentsThemeMap$s = componentsThemeMap[style],
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    background = _componentsThemeMap$s.background;
  const spacingBottom = hasMedia ? {
    sm: 7,
    md: 15
  } : style !== 'default' ? {
    sm: 4,
    md: 7
  } : 0;
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "ActionBannerCenter",
      children: /*#__PURE__*/jsxs(SectionComponentLayout, {
        as: "section",
        hasSpacingTop: hasSpacingTop,
        hasSpacingHorizontal: true,
        anchor: anchor,
        hasNonDefaultBackgroundSpacingTop: true,
        background: background,
        children: [/*#__PURE__*/jsxs(Div, {
          flexDirection: "column",
          alignItems: "center",
          spacingBottom: spacingBottom,
          children: [/*#__PURE__*/jsx(Div, {
            children: /*#__PURE__*/jsx(Text, {
              variant: {
                sm: 'title2',
                lg: 'display2'
              },
              as: "h2",
              color: foregroundSecondary,
              css: {
                textAlign: 'center'
              },
              children: headline
            })
          }), subhead && /*#__PURE__*/jsx(Text, {
            variant: "body",
            as: "p",
            spacingTop: 2,
            color: foregroundSecondary,
            css: {
              textAlign: 'center'
            },
            children: subhead
          }), /*#__PURE__*/jsx(Div, {
            children: /*#__PURE__*/jsx(CTAButtons, {
              ctaButtonLabel: ctaButtonLabel,
              ctaButtonUrl: ctaButtonUrl,
              contentBackground: background
            })
          })]
        }), hasMedia && /*#__PURE__*/jsx(ImageFullWidth, {
          src: mediaUrl,
          altText: mediaAlt
        })]
      })
    })
  });
}
export { ActionBannerCenter };
//# sourceMappingURL=ActionBannerCenter.js.map
